import { render, staticRenderFns } from "./NationalPatentForm.vue?vue&type=template&id=ab92f4e0&"
import script from "./NationalPatentForm.vue?vue&type=script&lang=js&"
export * from "./NationalPatentForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentForm.vue?vue&type=style&index=0&id=ab92f4e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports